'use client';

import { useContext } from 'react';
import { P5BasicAppContext } from './P5BasicAppProvider';

export const useP5BasicApp = () => useContext(P5BasicAppContext)!;
